module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG9161e8183223beabf04871a363a490c5.9161e818.png";